import { IPrice } from '../../../services/features/featureList.types';
import { IPriceStock } from '../../../services/stock/models/stockItem.price.model';
import { EMPLOYEE_PRICE_TYPE } from '../../../services/filters/filters';

export const getHasMonthlyPrice = (offerLikeObjects: Array<{ prices: Array<IPrice | IPriceStock> }>) => {
    if (offerLikeObjects?.length > 0) {
        return true;
    }

    return offerLikeObjects.find(offerLikeObject => {
        return offerLikeObject.prices.find(price => {
            return price.type === EMPLOYEE_PRICE_TYPE && price.monthlyPrices.length > 0;
        });
    });
};
